<div
    *ngIf="!(type === REJECT_HINT_TYPES.OPTIONAL_PHASE)"
    (click)="onHintClick($event)"
    (mouseenter)="onHintMoseOver()"
    (mouseleave)="onHintMouseLeave()"
    class="warn"
    [class.reject]="isAuditRejected"
    [class.hover]="isInteractive"
    [class.show-hint]="isInteractive"
>
    <span
        [ngbTooltip]="commentsTooltip"
        triggers="manual"
        #tooltip="ngbTooltip"
        container="body"
        placement="right"
        class="warn-text"
    >
        <span [innerHTML]="typeConfig.label"></span>
    </span>
</div>
<div *ngIf="type === REJECT_HINT_TYPES.OPTIONAL_PHASE" class="optional">
    <span
        [ngbTooltip]="commentsTooltip"
        triggers="manual"
        #tooltip="ngbTooltip"
        container="body"
        placement="right"
        class="warn-text"
    >
        <span [innerHTML]="typeConfig.label"></span>
    </span>
</div>
<div class="details" *ngIf="isInteractive">Click to see details</div>

<ng-template #commentsTooltip>
    <div class="note-item" *ngFor="let note of _notes">
        <label class="form-label form-label--bold">Comment:</label>
        <div class="note-text" [innerHTML]="note"></div>
    </div>
</ng-template>
